module.exports = __webpack_public_path__ + "static/media/youtube_button.7aa8d9de.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/img/youtube_button.png
// module id = 396
// module chunks = 2